import { BodyPartFilter } from './body-part/body-part-filter'
import { CompletedWorkoutsToggle } from './completed-workouts-toggle'
import { DurationFilter } from './duration-filter'
import { EquipmentFilter } from './equipment-filter'
import { FilterSection } from './filter-section'
import styles from './filter-sidebar.module.scss'
import { IntensityFilter } from './intensity-filter'
import { TrainerFilter } from './trainer-filter'
import { WorkoutStyleFilter } from './workout-style-filter'
import { WorkoutTypeFilter } from './workout-type-filter'
import { useFilterContext } from '../../context/filter-context'
import { ReactElement } from 'react'
import { Button } from 'src/component/ui/button'
import { useTrainers } from 'src/hook/use-trainers'

/**
 * The filter panel's contents (GH-754), shared by the desktop rail (FilterSidebar) and the mobile
 * bottom sheet (MobileFilters) so the two never drift. Returns the FILTERS heading, the fixed-order
 * filter sections, and Reset Filters as siblings — the wrapper decides their layout (the rail pins
 * Reset to the bottom; the sheet stacks them). Selections apply in real time via the filter context:
 * Trainer → Duration → Intensity → Workout Type → Workout Style → Equipment → Body Part →
 * Completed Workouts toggle → Reset Filters.
 */
export const FilterPanelBody = (): ReactElement => {
  const { data: trainers = [] } = useTrainers()
  const { clear } = useFilterContext()

  return (
    <>
      <FilterSection withSeparator={false}>
        <div className={styles.sidebarHeading}>
          <span className="font-evogria text-2xl leading-8 text-primary uppercase">FILTERS</span>
        </div>
      </FilterSection>
      <div className={`flex-shrink-1 ${styles.sidebarFiltersContainer}`}>
        <TrainerFilter trainers={trainers ?? []} />
        <DurationFilter />
        <IntensityFilter />
        <WorkoutTypeFilter />
        <WorkoutStyleFilter />
        <EquipmentFilter />
        <BodyPartFilter />
        <FilterSection>
          <CompletedWorkoutsToggle />
        </FilterSection>
      </div>
      <div className="flex justify-center py-4">
        <Button onClick={clear}>Reset Filters</Button>
      </div>
    </>
  )
}
